import { useState, useEffect } from "react";

//API
import API from "../API";

//Helpers
import { isPersistedState } from "../helper";

const initialState = {
    page: 0,
    results: [],
    total_pages: 0,
    total_results: 0,
};

export const useMoviesFetch = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [state, setState] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [loadMore, setLoadMore] = useState(false);

    const fetchMovies = async (searchTerm = "", page) => {
        try {
            setError(false);
            setLoading(true);

            const movies = await API.fetchMovies(searchTerm, page);

            setState(prev => ({
                ...movies,
                results:
                    page > 1
                        ? [...prev.results, ...movies.results]
                        : [...movies.results],
            }));
            setLoading(false);
        } catch (error) {
            setError(true);
            setLoading(false);
        }
    };

    // Search and initial
    useEffect(() => {
        if (!searchTerm) {
            const sessionState = isPersistedState("homeState");

            if (sessionState) {
                setState(sessionState);
                return;
            }
        }

        setState(initialState);
        fetchMovies(searchTerm, 1);
    }, [searchTerm]);

    //Load more
    useEffect(() => {
        if (!loadMore) return;

        fetchMovies(searchTerm, state.page + 1);
        setLoadMore(false);
    }, [loadMore, searchTerm, state.page]);

    //Write to session storage
    useEffect(() => {
        if (!searchTerm) {
            sessionStorage.setItem("homeState", JSON.stringify(state));
        }
    }, [searchTerm, state]);

    return { state, loading, error, searchTerm, setSearchTerm, setLoadMore };
};

export const useMovieFetch = movieId => {
    const [state, setState] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchMovie = async () => {
            try {
                setLoading(true);
                setError(false);

                const movie = await API.fetchMovie(movieId);
                const credits = await API.fetchCredits(movieId);

                //Get Directors
                const directors = credits.crew.filter(
                    member => member.job === "Director"
                );

                setState({
                    ...movie,
                    actors: credits.cast,
                    directors,
                });

                //Write to session storage
                sessionStorage.setItem(
                    movieId,
                    JSON.stringify({
                        ...movie,
                        actors: credits.cast,
                        directors,
                    })
                );

                setLoading(false);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        };

        const sessionState = isPersistedState(movieId);
        if (sessionState) {
            setState(sessionState);
            setLoading(false);
            return;
        }
        fetchMovie();
    }, [movieId]);

    return { state, loading, error };
};
